import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export type WimsStatusType = {
  active: number;
  issues: number;
  nonActive: number;
  damaged: number;
  total: number;
};

export interface WimsStatusState {
  data: WimsStatusType;
  isLoading: boolean;
  error: Error | null;
}

const initialState: WimsStatusState = {
  data: {
    active: 0,
    issues: 0,
    nonActive: 0,
    damaged: 0,
    total: 0,
  },
  isLoading: false,
  error: null,
};

const wimsStatusInfo = createSlice({
  name: 'wimsStatusInfo',
  initialState,
  reducers: {
    requestWimsStatusInfo: (state, _payload): void => {
      state.isLoading = true;
    },
    setIsLoading: (state, { payload }: PayloadAction<boolean>): void => {
      state.isLoading = payload;
    },
    getWimsStatusSuccess: (state, { payload }): void => {
      state.isLoading = false;
      state.data = payload;
    },
    getWimsStatusError: (state, { payload }): void => {
      state.isLoading = false;
      state.error = payload;
    },
  },
});

export const { requestWimsStatusInfo, getWimsStatusSuccess, getWimsStatusError, setIsLoading } = wimsStatusInfo.actions;

export default wimsStatusInfo.reducer;
